import {get} from "@/utils/http"

export const _statistical = params => get("/index/statistical", params);



